import React from 'react'
import PropTypes from 'prop-types'
import './CloseButton.scss'

const CloseButton = props => {
  const { closeAction, src } = props

  return (
    <button
      onClick={closeAction}
      className='close-button mr15 curp'
      aria-label='Close'
    >
      <img src={src} alt='close icon' />
    </button>
  )
}

CloseButton.propTypes = {
  closeAction: PropTypes.func.isRequired,
  src: PropTypes.string.isRequired
}

export default CloseButton


